import { render, staticRenderFns } from "./FinalInfo.vue?vue&type=template&id=10bb9a03"
import script from "./FinalInfo.vue?vue&type=script&lang=js"
export * from "./FinalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports